export default "__VITE_ASSET__C9u1PHXD__"